import { render, staticRenderFns } from "./addHotel.vue?vue&type=template&id=83a5e3d8"
import script from "./addHotel.vue?vue&type=script&lang=js"
export * from "./addHotel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports